"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isTerminalCacheKeyMap(map) {
    return map.hasOwnProperty('cacheKey');
}
exports.isTerminalCacheKeyMap = isTerminalCacheKeyMap;
function isRootCacheKeyMap(map) {
    return map.hasOwnProperty('parentMap');
}
exports.isRootCacheKeyMap = isRootCacheKeyMap;
//# sourceMappingURL=cache-key-maps.js.map